import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { findBriefing } from "@/data/briefings";
import { PageShell, GoldButton } from "@/components/ds";
import ArticleLayout from "@/components/ds/ArticleLayout";
import { setPageMeta, injectJsonLd, SITE } from "@/lib/seo";

const InsightArticle = () => {
  const { slug } = useParams();
  const article = findBriefing(slug);

  useEffect(() => {
    if (!article) return;
    setPageMeta({
      title: `${article.shortTitle || article.title} | Zorem`,
      description: article.dek,
      path: `/insights/${article.slug}`,
      type: "article",
    });
    injectJsonLd("article-jsonld", {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Article",
          headline: article.title,
          description: article.dek,
          keywords: (article.tags || []).join(", "),
          datePublished: "2026-07-01",
          dateModified: "2026-09-08",
          inLanguage: "en",
          author: { "@type": "Organization", name: "Zorem Commodities LLC", url: SITE },
          publisher: {
            "@type": "Organization",
            name: "Zorem Commodities LLC",
            logo: { "@type": "ImageObject", url: `${SITE}/assets/logo-mark.webp` },
          },
          image: `${SITE}/assets/og-image.jpg`,
          mainEntityOfPage: `${SITE}/insights/${article.slug}`,
        },
        {
          "@type": "BreadcrumbList",
          itemListElement: [
            { "@type": "ListItem", position: 1, name: "Home", item: `${SITE}/` },
            { "@type": "ListItem", position: 2, name: "Insights", item: `${SITE}/insights` },
            { "@type": "ListItem", position: 3, name: article.title },
          ],
        },
      ],
    });
    return () => document.getElementById("article-jsonld")?.remove();
  }, [article]);

  if (!article) {
    return (
      <PageShell eyebrow="Insights" title="Briefing not found">
        <p className="text-zinc-400">This briefing does not exist or has been archived.</p>
        <div className="mt-8"><GoldButton to="/insights" variant="ghost" testid="article-back-home">All briefings</GoldButton></div>
      </PageShell>
    );
  }

  return <ArticleLayout article={article} />;
};

export default InsightArticle;
